/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendEmailVerification
 */
export interface ResendEmailVerification {
    /**
     * 
     * @type {string}
     * @memberof ResendEmailVerification
     */
    email: string;
}

/**
 * Check if a given object implements the ResendEmailVerification interface.
 */
export function instanceOfResendEmailVerification(value: object): value is ResendEmailVerification {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ResendEmailVerificationFromJSON(json: any): ResendEmailVerification {
    return ResendEmailVerificationFromJSONTyped(json, false);
}

export function ResendEmailVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendEmailVerification {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

  export function ResendEmailVerificationToJSON(json: any): ResendEmailVerification {
      return ResendEmailVerificationToJSONTyped(json, false);
  }

  export function ResendEmailVerificationToJSONTyped(value?: ResendEmailVerification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

